import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISocialMediaEntryEnvironment } from 'projects/shared/lib/interfaces/environment/social/social-entry-environment.interface';
import { APPTRANSLATIONS } from 'projects/shared/lib/i18n/translations';

@Component({
  selector: 'app-external-links',
  imports: [CommonModule],
  templateUrl: './external-links.component.html',
  styleUrls: ['./external-links.component.scss']
})
export class ExternalLinksComponent {
  // ToDo: refactor this to use a different / more flexible approach than ISocialMediaEntryEnvironment to skip the icon which is currently mandatory.
  @Input() public linkList: ISocialMediaEntryEnvironment[] | undefined;
  public appTranslations = APPTRANSLATIONS;
}
